export const hasCartProductImage = product => Array.isArray(product?.images) && product.images.length > 0
